import {
  ErrorBoundary,
  ModalContainer,
  ThemeProvider,
  useTheme
} from '@convergence/components';
import '@convergence/components/dist/components.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { queryClient } from '../api/query-client';
import { AuthProvider } from '../components/AuthProvider';
import { PopoverProvider } from '../components/Popover';

const ToastContainerWrapper = () => {
  const theme = useTheme();

  return <ToastContainer theme={theme.darkMode ? 'dark' : 'light'} />;
};

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <ErrorBoundary>
      <ModalContainer>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <ThemeProvider>
              <PopoverProvider>
                <BrowserRouter>{children}</BrowserRouter>
              </PopoverProvider>
            </ThemeProvider>
          </AuthProvider>
        </QueryClientProvider>
      </ModalContainer>
      <ToastContainerWrapper />
    </ErrorBoundary>
  );
}
